export default "__VITE_ASSET__C$gPPWaW__"